/* Contara article sticky CTA (CNV-6396) */
(function () {
  var SCROLL_START = 10;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function headerOffset() {
    var header = document.querySelector('[data-ctr-article-header]');
    if (!header) return 0;
    var section = header.closest('.shopify-section') || header;
    return getComputedStyle(section).position === 'sticky' ? header.offsetHeight : 0;
  }

  function inView(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  function init(bar) {
    var sentinel = bar.parentElement.querySelector('[data-ctr-sticky-cta-sentinel]');
    var triggerId = bar.getAttribute('data-trigger-id');
    var buyId = bar.getAttribute('data-buy-id');
    var hideAtEnd = bar.hasAttribute('data-hide-at-end');
    var liftSelector = bar.getAttribute('data-lift-selector');
    var visible = false;
    var ticking = false;

    // Show from the trigger (Prevention Serum banner) onward: its top has reached the
    // viewport bottom, or it is already scrolled past. Fallback: the buy box itself,
    // so the bar never appears before the product is featured. Last resort: scroll.
    function reached() {
      var trigger = (triggerId && document.getElementById(triggerId)) ||
        (buyId && document.getElementById(buyId));
      if (trigger) return trigger.getBoundingClientRect().top < window.innerHeight;
      return window.scrollY > SCROLL_START;
    }

    function setVisible(show) {
      if (show === visible) return;
      visible = show;
      bar.classList.toggle('is-visible', show);
      if (show) {
        bar.removeAttribute('inert');
        bar.removeAttribute('aria-hidden');
        document.documentElement.style.setProperty('--ctr-sticky-cta-h', bar.offsetHeight + 'px');
      } else {
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
      }
      document.documentElement.classList.toggle('ctr-sticky-cta-active', show);
    }

    // Third-party floating widgets (e.g. Klaviyo teaser) pinned near the bottom of the
    // screen are tagged once; CSS lifts them by the bar height while the bar is shown.
    // Full-screen popups and elements away from the bottom edge are skipped.
    function tagFloating() {
      if (!liftSelector) return;
      var els;
      try { els = document.querySelectorAll(liftSelector); } catch (e) { return; }
      var vh = window.innerHeight;
      els.forEach(function (el) {
        if (el.hasAttribute('data-ctr-sticky-lift') || bar.contains(el)) return;
        if (getComputedStyle(el).position !== 'fixed') return;
        var r = el.getBoundingClientRect();
        if (!r.height || r.height > vh * 0.6 || r.bottom < vh - 160) return;
        el.setAttribute('data-ctr-sticky-lift', '');
      });
    }

    function update() {
      ticking = false;
      tagFloating();
      var buy = buyId ? document.getElementById(buyId) : null;
      setVisible(reached() && !inView(buy) && !(hideAtEnd && inView(sentinel)));
    }
    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      if (visible) document.documentElement.style.setProperty('--ctr-sticky-cta-h', bar.offsetHeight + 'px');
      schedule();
    });

    var link = bar.querySelector('a[href^="#"]');
    if (link) {
      link.addEventListener('click', function (event) {
        var hash = link.getAttribute('href');
        var target = hash.length > 1 ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
        if (!target) return;
        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - headerOffset() - 12;
        window.scrollTo({ top: top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', hash);
      });
    }

    if (liftSelector && window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }

    update();
  }

  function start() {
    document.querySelectorAll('[data-ctr-sticky-cta]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
